import React from 'react';
import Modal from "../common/Modal";

/**
 * A modal that prompts the user with a warning before dismissing all changes.
 *
 * @param {boolean} isOpen - Whether the modal is open or not.
 * @param {Function} onOk - The function to call when the user clicks "Go Back".
 * @param {Function} onCancel - The function to call when the user clicks "Dismiss all changes".
 */
function DismissChangeModal({
  isOpen,
  onOk,
  onCancel
}) {

  return (
    <Modal isOpen={isOpen}>
      <div className="custom-modal-content">
        <h5 className="custom-modal-message text-center">
          Dismiss all change?
        </h5>
        <div className="custom-modal-description text-center">
          This operation cannot be undone
        </div>
      </div>

      {/* modal actions */}
      <div className="custom-modal-action">
        <button
          className="btn btn-secondary"
          type="submit"
          onClick={onCancel}
        >
          Dismiss all changes
        </button>

        <button
          className="btn btn-warning"
          type="submit"
          onClick={onOk}
        >
          Go Back
        </button>

      </div>
    </Modal>
  )
}

export default DismissChangeModal;
